import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const statusStateSelector = (state: RootState) => state.status;

export const statusSelectors = {
  isLoading: createSelector(statusStateSelector, s => s.isLoading),
  isError: createSelector(statusStateSelector, s => s.isError),
  errorCode: createSelector(statusStateSelector, s => s.errorCode),
  isSuccess: createSelector(statusStateSelector, s => s.isSuccess),
  isUninitialized: createSelector(statusStateSelector, s => s.isUninitialized),
  error: createSelector(statusStateSelector, s => s.error),
  data: createSelector(statusStateSelector, s => s.data),
  stepValues: createSelector(statusStateSelector, s => s.stepValues),
  lastAction: createSelector(statusStateSelector, s => s.lastAction),
  currentStep: createSelector(statusStateSelector, s => s.currentStep),
  redirectError: createSelector(statusStateSelector, s => s.redirectError),
};
